// Ported from dev-scrips-pm-react src/billing/lib/line-chip.ts (PROD-3312 appointment Billing tab).
/**
 * The small blue chip under a services-table line name. One visual language for
 * everything that explains where a line came from or why it costs what it
 * costs: the membership price (PROD-2152), the patient's receipts list, and
 * "Added by <name>" on a line added from a pending order (PROD-2592).
 */
export const LINE_CHIP_CLASS =
  'mt-0.5 inline-flex items-center gap-1 rounded-sm bg-blue-100/40 px-1.5 py-0.5 text-size-xs font-medium text-brand-depth';

/**
 * The label on a line added from a pending order (PROD-2681): "Added by <name>",
 * or "Added" when no name is recorded (null, undefined or blank). The line chip
 * and the Add-orders confirm dialog both use this, so their wording can't drift.
 */
export function addedByLabel(name: string | null | undefined): string {
  const who = name?.trim();
  return who ? `Added by ${who}` : 'Added';
}
